import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

function GestionProfils() {
  const [profils, setProfils] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingProfil, setEditingProfil] = useState(null);
  const [formData, setFormData] = useState({
    nom: '',
    sections: [],
    inclus_dans_planning: false
  });

  // Liste de toutes les sections disponibles
  const allSections = [
    { id: 'profils', label: 'Gestion des profils' },
    { id: 'operateurs', label: 'Gestion des opérateurs' },
    { id: 'produits', label: 'Gestion des produits' },
    { id: 'codebarre', label: 'Gestion des codes-barres' },
    { id: 'production', label: 'Gestion de la production' },
    { id: 'planning', label: 'Planning de production' },
    { id: 'revendeurs', label: 'Gestion des revendeurs' },
    { id: 'ffm', label: 'Module FFM' },
    { id: 'stock', label: 'Gestion des stocks' },
    { id: 'acces-operateur', label: 'Accès opérateur' }
  ];

  useEffect(() => {
    loadProfils();
  }, []);

  const loadProfils = async () => {
    const { data, error } = await supabase
      .from('profils')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) {
      console.error('Erreur chargement profils:', error);
    } else {
      setProfils(data || []);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (editingProfil) {
      const { error } = await supabase
        .from('profils')
        .update(formData)
        .eq('id', editingProfil.id);
      
      if (error) {
        console.error('Erreur mise à jour:', error);
        alert('Erreur lors de la mise à jour du profil');
      } else {
        loadProfils();
        closeModal();
      }
    } else {
      const { error } = await supabase
        .from('profils')
        .insert([formData]);
      
      if (error) {
        console.error('Erreur création:', error);
        alert('Erreur lors de la création du profil');
      } else {
        loadProfils();
        closeModal();
      }
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce profil ?')) {
      const { error } = await supabase
        .from('profils')
        .delete()
        .eq('id', id);
      
      if (error) {
        console.error('Erreur suppression:', error);
        alert('Erreur lors de la suppression. Ce profil est peut-être utilisé par des opérateurs.');
      } else {
        loadProfils();
      }
    }
  };

  const openModal = (profil = null) => {
    if (profil) {
      setEditingProfil(profil);
      setFormData({
        nom: profil.nom,
        sections: Array.isArray(profil.sections) ? profil.sections : [],
        inclus_dans_planning: profil.inclus_dans_planning || false
      });
    } else {
      setEditingProfil(null);
      setFormData({
        nom: '',
        sections: [],
        inclus_dans_planning: false
      });
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingProfil(null);
    setFormData({
      nom: '',
      sections: [],
      inclus_dans_planning: false
    });
  };

  const toggleSection = (sectionId) => {
    setFormData(prev => {
      const sections = [...prev.sections];
      const index = sections.indexOf(sectionId);
      
      if (index > -1) {
        sections.splice(index, 1);
      } else {
        sections.push(sectionId);
      }
      
      return { ...prev, sections };
    });
  };

  const toggleAllSections = () => {
    if (formData.sections.length === allSections.length) {
      setFormData(prev => ({ ...prev, sections: [] }));
    } else {
      setFormData(prev => ({ ...prev, sections: allSections.map(s => s.id) }));
    }
  };

  return (
    <div>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '40px'
      }}>
        <div>
          <h1 style={{ 
            color: '#212529',
            fontSize: '32px',
            fontWeight: '600',
            margin: 0,
            marginBottom: '8px'
          }}>
            Gestion des Profils
          </h1>
          <p style={{ 
            color: '#6c757d',
            fontSize: '15px',
            margin: 0
          }}>
            Créez des profils et définissez les sections accessibles
          </p>
        </div>
        <button
          onClick={() => openModal()}
          style={{
            padding: '14px 32px',
            backgroundColor: '#1aabf9',
            color: '#ffffff',
            border: 'none',
            borderRadius: '10px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(26, 171, 249, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 25px rgba(26, 171, 249, 0.4)';
            e.target.style.backgroundColor = '#0d96e6';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(26, 171, 249, 0.3)';
            e.target.style.backgroundColor = '#1aabf9';
          }}
        >
          + Nouveau Profil
        </button>
      </div>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))',
        gap: '24px'
      }}>
        {profils.map(profil => {
          const sectionsArray = Array.isArray(profil.sections) ? profil.sections : [];
          return (
            <div
              key={profil.id}
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '15px',
                padding: '28px',
                border: '1px solid #e0e5ea',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.border = '1px solid #1aabf9';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(26, 171, 249, 0.15)';
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.border = '1px solid #e0e5ea';
                e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.05)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '20px' }}>
                <h3 style={{ 
                  color: '#212529',
                  marginTop: 0,
                  marginBottom: 0,
                  fontSize: '20px',
                  fontWeight: '600'
                }}>
                  {profil.nom}
                </h3>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  {profil.inclus_dans_planning && (
                    <span style={{
                      backgroundColor: '#d1fae5',
                      color: '#059669',
                      padding: '4px 12px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}>
                      📅 Planning
                    </span>
                  )}
                  <span style={{
                    backgroundColor: '#e3f2fd',
                    color: '#1aabf9',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: '600'
                  }}>
                    {sectionsArray.length} sections
                  </span>
                </div>
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <div style={{ 
                  color: '#6c757d',
                  fontSize: '13px',
                  fontWeight: '600',
                  marginBottom: '10px'
                }}>
                  ACCÈS AUTORISÉS :
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {sectionsArray.length === 0 ? (
                    <span style={{ color: '#dc3545', fontSize: '13px', fontStyle: 'italic' }}>
                      Aucun accès configuré
                    </span>
                  ) : (
                    sectionsArray.map(sectionId => {
                      const section = allSections.find(s => s.id === sectionId);
                      return (
                        <span
                          key={sectionId}
                          style={{
                            backgroundColor: '#f8f9fa',
                            color: '#495057',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            border: '1px solid #dee2e6'
                          }}
                        >
                          {section ? section.label : sectionId}
                        </span>
                      );
                    })
                  )}
                </div>
              </div>
              
              <div style={{ 
                display: 'flex', 
                gap: '10px',
                marginTop: '20px',
                paddingTop: '20px',
                borderTop: '1px solid #e0e5ea'
              }}>
                <button
                  onClick={() => openModal(profil)}
                  style={{
                    flex: 1,
                    padding: '10px 20px',
                    backgroundColor: '#1aabf9',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    transition: 'all 0.3s ease',
                    fontWeight: '600'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#0d96e6';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#1aabf9';
                  }}
                >
                  Modifier
                </button>
                <button
                  onClick={() => handleDelete(profil.id)}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: 'transparent',
                    color: '#dc3545',
                    border: '1px solid #dc3545',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    transition: 'all 0.3s ease',
                    fontWeight: '600'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#dc3545';
                    e.target.style.color = '#ffffff';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#dc3545';
                  }}
                >
                  Supprimer
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {profils.length === 0 && (
        <div style={{
          textAlign: 'center',
          padding: '80px 20px',
          color: '#6c757d',
          fontSize: '15px',
          backgroundColor: '#ffffff',
          borderRadius: '15px',
          border: '2px dashed #dee2e6'
        }}>
          Aucun profil créé. Cliquez sur "Nouveau Profil" pour commencer.
        </div>
      )}

      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: '#ffffff',
            borderRadius: '20px',
            padding: '40px',
            width: '600px',
            maxWidth: '90%',
            maxHeight: '90vh',
            overflow: 'auto',
            border: '2px solid #1aabf9',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
          }}>
            <h2 style={{ 
              color: '#212529',
              marginTop: 0,
              marginBottom: '30px',
              fontSize: '24px',
              fontWeight: '600'
            }}>
              {editingProfil ? 'Modifier le profil' : 'Nouveau profil'}
            </h2>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '30px' }}>
                <label style={{ 
                  display: 'block',
                  color: '#495057',
                  marginBottom: '10px',
                  fontSize: '14px',
                  fontWeight: '600'
                }}>
                  Nom du profil
                </label>
                <input
                  type="text"
                  value={formData.nom}
                  onChange={(e) => setFormData({...formData, nom: e.target.value})}
                  required
                  placeholder="Ex: Manager, Superviseur, Technicien..."
                  style={{
                    width: '100%',
                    padding: '14px 18px',
                    backgroundColor: '#f8f9fa',
                    color: '#212529',
                    border: '1px solid #dee2e6',
                    borderRadius: '10px',
                    fontSize: '15px',
                    outline: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onFocus={(e) => {
                    e.target.style.border = '2px solid #1aabf9';
                    e.target.style.backgroundColor = '#ffffff';
                  }}
                  onBlur={(e) => {
                    e.target.style.border = '1px solid #dee2e6';
                    e.target.style.backgroundColor = '#f8f9fa';
                  }}
                />
              </div>

              <div style={{ marginBottom: '30px' }}>
                <label style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  padding: '16px 20px',
                  backgroundColor: formData.inclus_dans_planning ? '#d1fae5' : '#f8f9fa',
                  border: formData.inclus_dans_planning ? '2px solid #059669' : '1px solid #dee2e6',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}>
                  <input
                    type="checkbox"
                    checked={formData.inclus_dans_planning}
                    onChange={(e) => setFormData({...formData, inclus_dans_planning: e.target.checked})}
                    style={{
                      marginRight: '12px',
                      width: '20px',
                      height: '20px',
                      cursor: 'pointer',
                      accentColor: '#059669'
                    }}
                  />
                  <div>
                    <div style={{
                      color: formData.inclus_dans_planning ? '#059669' : '#495057',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}>
                      📅 Comptabiliser dans le planning de production
                    </div>
                    <div style={{
                      color: '#6c757d',
                      fontSize: '12px',
                      marginTop: '4px'
                    }}>
                      Les heures des opérateurs de ce profil seront comptées dans la capacité de production
                    </div>
                  </div>
                </label>
              </div>

              <div style={{ marginBottom: '30px' }}>
                <div style={{ 
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '15px'
                }}>
                  <label style={{ 
                    color: '#495057',
                    fontSize: '14px',
                    fontWeight: '600'
                  }}>
                    Sections accessibles
                  </label>
                  <button
                    type="button"
                    onClick={toggleAllSections}
                    style={{
                      padding: '6px 12px',
                      backgroundColor: 'transparent',
                      color: '#1aabf9',
                      border: '1px solid #1aabf9',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '600',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#1aabf9';
                      e.target.style.color = '#ffffff';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = '#1aabf9';
                    }}
                  >
                    {formData.sections.length === allSections.length ? 'Tout désélectionner' : 'Tout sélectionner'}
                  </button>
                </div>

                <div style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #dee2e6',
                  borderRadius: '10px',
                  padding: '20px'
                }}>
                  {allSections.map(section => (
                    <label
                      key={section.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '12px',
                        marginBottom: '8px',
                        backgroundColor: formData.sections.includes(section.id) ? '#e3f2fd' : '#ffffff',
                        border: formData.sections.includes(section.id) ? '2px solid #1aabf9' : '1px solid #dee2e6',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (!formData.sections.includes(section.id)) {
                          e.currentTarget.style.backgroundColor = '#f8f9fa';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!formData.sections.includes(section.id)) {
                          e.currentTarget.style.backgroundColor = '#ffffff';
                        }
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={formData.sections.includes(section.id)}
                        onChange={() => toggleSection(section.id)}
                        style={{
                          marginRight: '12px',
                          width: '20px',
                          height: '20px',
                          cursor: 'pointer',
                          accentColor: '#1aabf9'
                        }}
                      />
                      <span style={{
                        color: formData.sections.includes(section.id) ? '#1aabf9' : '#495057',
                        fontSize: '14px',
                        fontWeight: formData.sections.includes(section.id) ? '600' : '500'
                      }}>
                        {section.label}
                      </span>
                    </label>
                  ))}
                </div>
                
                <div style={{
                  marginTop: '10px',
                  padding: '10px',
                  backgroundColor: '#fff3cd',
                  border: '1px solid #ffc107',
                  borderRadius: '8px',
                  fontSize: '13px',
                  color: '#856404'
                }}>
                  💡 <strong>Astuce :</strong> Sélectionnez uniquement les sections nécessaires pour chaque profil afin de sécuriser l'accès à votre application.
                </div>
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={closeModal}
                  style={{
                    padding: '12px 28px',
                    backgroundColor: 'transparent',
                    color: '#6c757d',
                    border: '1px solid #dee2e6',
                    borderRadius: '10px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#f8f9fa';
                    e.target.style.color = '#212529';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#6c757d';
                  }}
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  style={{
                    padding: '12px 28px',
                    backgroundColor: '#1aabf9',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '10px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#0d96e6';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#1aabf9';
                  }}
                >
                  {editingProfil ? 'Mettre à jour' : 'Créer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default GestionProfils;